import { render, staticRenderFns } from "./TeamCard.vue?vue&type=template&id=2a4ae412&scoped=true&"
import script from "./TeamCard.vue?vue&type=script&lang=js&"
export * from "./TeamCard.vue?vue&type=script&lang=js&"
import style0 from "./TeamCard.vue?vue&type=style&index=0&id=2a4ae412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ae412",
  null
  
)

export default component.exports